import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import chroma from 'chroma-js';

function generateTextColor(colorPalletes) {
  var colorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var colorSchemeIsBright = chroma(colorPalletes[colorScheme]).luminance() > 0.5;

  if (type === 'primary') {
    return colorSchemeIsBright ? colorPalletes.dark : colorPalletes.light;
  }

  return colorPalletes[colorScheme];
}

/** @@deprecated */
var ZoneElement = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    color: ", ";\n    \n"])), function (props) {
  return props.theme.fontSizes[props.fontSize];
}, function (props) {
  return generateTextColor(props.theme.colors, props.zoneScheme, props.type);
});
export default ZoneElement;